import { SkeletonThemeProvider } from '@eika/skeleton';
import { loadContainers } from '@eika-infrastruktur/render';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import './index.scss';
import { AppContextProvider } from '@context/app-context-provider';
import { type Config, defaultConfig } from '@default-config';
import { SavingsCalculatorLoggedInPagesWidget } from '@widgets/savings-calculator-logged-in-pages/savings-calculator-logged-in-pages';
import { SavingsCalculatorOpenPagesWidget } from '@widgets/savings-calculator-open-pages/savings-calculator-open-pages';

const globalCssNamespace = 'scw'; // AKA: Sparing Calculator Web (so change to your own app namespace)
export const REPO_NAMESPACE = 'sparing';

const staleTime = 60 * 60 * 5; // 5 min
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime,
            retry: 1,
            refetchOnWindowFocus: false,
            refetchIntervalInBackground: false,
            retryOnMount: false,
        },
    },
});

const renderApp = (MyApp: React.ComponentType, namespace: string, appDefaultConfig: Config = defaultConfig): void => {
    loadContainers(
        `${REPO_NAMESPACE}.${namespace}`,
        () => (
            <React.StrictMode>
                <QueryClientProvider client={queryClient}>
                    <AppContextProvider>
                        <SkeletonThemeProvider>
                            <div className={globalCssNamespace}>
                                <MyApp />
                            </div>
                        </SkeletonThemeProvider>
                    </AppContextProvider>
                </QueryClientProvider>
            </React.StrictMode>
        ),
        appDefaultConfig,
    );
};

renderApp(SavingsCalculatorOpenPagesWidget, 'calculator-web.savings-calculator');
renderApp(SavingsCalculatorLoggedInPagesWidget, 'calculator-web.savings-calculator-logged-in-pages');
